import React from "react";
import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";
import { ShieldOff, LogOut } from "lucide-react";

export default function SemAcesso() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <div data-testid="sem-acesso-page" className="mx-auto max-w-md py-10 text-center">
      <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-amber-100 text-amber-700">
        <ShieldOff size={28} />
      </div>
      <h1 className="text-2xl font-bold text-slate-900">Você não tem acesso a nenhuma área</h1>
      <p className="mt-2 text-sm text-slate-600">
        Olá, <strong>{user?.name}</strong>. Sua conta ainda não tem permissões liberadas.
        Fale com o administrador para receber acesso.
      </p>
      <button
        onClick={handleLogout}
        data-testid="sem-acesso-sair"
        className="mt-6 inline-flex items-center gap-2 rounded-md bg-slate-900 px-5 py-2.5 text-sm font-bold text-white hover:bg-slate-800"
      >
        <LogOut size={16} /> Sair
      </button>
    </div>
  );
}
